export const sellLeadType = [
    'PostLeadFormAlsoSelling',
    'OffMarketCombinationBuySell',
    'PostClaimHomeAlsoSelling',
    'HaveAHomeToSell',
    'HelpMeSell',
    'MSPHometoSell',
    'InlineHotleadInSellLandingPageReferral_seller',
    'PopupHotleadInSellLandingPageReferral_seller',
    'InlineHotleadInAgentProfilePage_seller',
    'PopupHotleadInAgentProfilePage_seller',
    'PopupHotleadInPricingTool_seller',
    'PriceEstimate_seller',
    'HomeValueEstimate',
    'HomeownerSell',
    'SellPageConnectWithAgent',
    'HomeownerSell_Digs',
    'SellPageCashOffer',
    'BuyingWhileSelling',
    'SellFastPageCashOffer',
    'LocalSellPageCashOffer',
    'LocalSellPageSell',
    'CashOfferBanner',
    'CashOfferCheckbox',
    'ConnectWithSellerAgent',
    'OffMarketCombinationSell',
    'OffMarketCombinationBuySell',
    'CashOfferPrimaryInactiveCTA',
    'CashOfferCheckboxActive',
    'HotmarketInactive',
    'RequestSellingConsultation_SoldPRDPP',
    'OpendoorCashOffer_SPRDPP',
];
